// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonToDashboard_root__11EdF"};